// extracted by mini-css-extract-plugin
export var container = "_dw-0";
export var icon = "_dw-1";
export var text = "_dw-2";